'use strict';
module.exports = require('../../full/promise');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/promise/index.js
// module id = 612
// module chunks = 13